import { render, staticRenderFns } from "./login-info-card.vue?vue&type=template&id=501d2d9a&scoped=true&"
import script from "./login-info-card.vue?vue&type=script&lang=js&"
export * from "./login-info-card.vue?vue&type=script&lang=js&"
import style0 from "./login-info-card.vue?vue&type=style&index=0&id=501d2d9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501d2d9a",
  null
  
)

export default component.exports